// extracted by mini-css-extract-plugin
module.exports = {"modalBtnContainer":"ClassDetailModal_modalBtnContainer__2LFO4","classDetail":"ClassDetailModal_classDetail__2JUpZ","classDetailLabel":"ClassDetailModal_classDetailLabel__39JDG"};